import u from "mitt";
const s = u();
function c(t, o) {
  s.on(t, o);
}
function m(t, o) {
  s.off(t, o);
}
function n(t, o, i) {
  const r = {
    payload: i,
    type: o
  };
  s.emit(t, r);
}
function f(t) {
  n(t, "submit");
}
function b(t) {
  n(t, "reset");
}
function F(t, o) {
  n(t, "setValues", o);
}
function a(t, o) {
  n(t, "setErrors", o);
}
export {
  b as resetForm,
  a as setFormErrors,
  F as setFormValues,
  f as submitForm,
  c as subscribe,
  m as unsubscribe
};
